export default {
  massRemove: 'Remove anomaly monitored connectors',
  massEnable: 'Enable anomaly monitored connectors',
  massDisable: 'Disable anomaly monitored connectors',
};
